<template>
	<div class="loader" v-bind:class="{
		soft: soft
	}">
		<div class="loader-inner">
			<img src="/img/loader.gif" />
		</div>
	</div>
</template>

<script>
export default {
  props: [
    'soft'
  ]
}
</script>

<style lang="less" scoped>
	.loader {
		display: flex;
		align-items: center;
		justify-content: center;
		background: transparent;
		position: fixed;
		top: 0px;
		bottom: 0px;
		left: 0px;
		right: 0px;
		&.soft {
			z-index: 1000;
			.loader-inner {
				background: #fff;
				padding: 10px;
				border: 3px solid #F28F86;
				border-radius: 4px;
				box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.3);
				img {
					width: 100px;
					height: 100px;
				}
			}
		}
		&.extra-soft {
			top: 100px;
			right: 50px;
			left: auto;
			bottom: auto;
			.loader-inner {
				img {
					width: 50px;
					height: 50px;
				}
			}
		}
	}
</style>
